export type CardAngle = {
  yaw: number
  pitch: number
  roll: number
}

type CardLocation = {
  x: number
  y: number
  z: number
}

type CardTransform = {
  perspective: number
  scale: number
  location: CardLocation
  rotation: CardAngle
}

export type CardStyle = {
  transform: CardTransform
  opacity: number
  blur: number
  cursor: string
}

export const ComputeTransformStr = (style: CardStyle) =>
  `perspective(${style.transform.perspective}px) translate3d(${style.transform.location.x}px, ${style.transform.location.y}px, ${style.transform.location.z}px) scale(${style.transform.scale}) rotateY(${style.transform.rotation.yaw}deg) rotateX(${style.transform.rotation.pitch}deg) rotateZ(${style.transform.rotation.roll}deg)`

const Interp = (a: number, b: number, dt: number, speed: number) => {
  if (a === b) {
    return a
  }
  const delta = (b - a) * dt * speed
  const result = a + delta

  // Clamp the result so we don't get oscillation for large speeds
  if (b > a) {
    return Math.min(Math.max(result, a), b)
  }
  return Math.min(Math.max(result, b), a)
}

export const InterpObj = (src: object, dest: object, dt: number, speed: number) => {
  const newObj = JSON.parse(JSON.stringify(src))

  for (const key in src) {
    if (key in src) {
      const curVal = src[key as keyof typeof src]
      const destVal = dest[key as keyof typeof src]
      if (typeof curVal === 'object') {
        newObj[key] = InterpObj(curVal, destVal, dt, speed)
      } else if (typeof curVal === 'number') {
        newObj[key] = Interp(curVal, destVal, dt, speed)
      } else {
        newObj[key] = destVal
      }
    }
  }

  return newObj
}
